import { Card } from "@/components/ui/card";

export const KpiCard = ({ label, value, sub, accent, icon: Icon, testId }) => {
  return (
    <Card
      data-testid={testId}
      className="p-5 border-gray-200 rounded-xl shadow-sm bg-white h-full flex flex-col justify-between"
    >
      <div className="flex items-start justify-between">
        <div className="text-xs font-bold uppercase tracking-[0.1em] text-gray-500">{label}</div>
        {Icon && (
          <div className={`h-8 w-8 rounded-lg flex items-center justify-center ${accent || "bg-gray-100 text-gray-700"}`}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="mt-3">
        <div className="font-display text-3xl font-black tracking-tight text-gray-900">{value}</div>
        {sub && <div className="mt-1 text-xs text-gray-500">{sub}</div>}
      </div>
    </Card>
  );
};
